'use client';

import React, { Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";

import Header from '../components/Header';
import Leftnav from '../components/Leftnav';
import Rightchat from '../components/Rightchat';
import Appfooter from '../components/Appfooter';
import Popupchat from '../components/Popupchat';

import Postview from '../components/Postview';
import Events from '../components/Events';
import Createpost from '../components/Createpost';
import Load from '../components/Load';
import Profilephoto from '../components/Profilephoto';
import ProfilecardThree from '../components/ProfilecardThree';
import Profiledetail from '../components/Profiledetail';

import { fetchPosts } from "../redux/slices/postSlice";
import { RootState } from "../redux/store";

const UPLOAD_URL = process.env.REACT_APP_UPLOAD_URL || "";

const Userpage: React.FC = () => {

    const dispatch = useDispatch<any>();
    const posts = useSelector((state: RootState) => state.posts.posts);

    useEffect(() => {
        dispatch(fetchPosts());
    }, [dispatch]);

    return (
        <Fragment>
            <Header />
            <Leftnav />
            <Rightchat />

            <div className="main-content right-chat-active">
                <div className="middle-sidebar-bottom">
                    <div className="middle-sidebar-left pe-0">
                        <div className="row">

                            {/* PROFILE HEADER */}
                            <div className="col-xl-12 mb-3">
                                <ProfilecardThree />
                            </div>

                            {/* LEFT SIDEBAR */}
                            <div className="col-xl-4 col-xxl-3 col-lg-4 pe-0">
                                <Profiledetail />
                                <Profilephoto />
                                <Events />
                            </div>

                            {/* FEED */}
                            <div className="col-xl-8 col-xxl-9 col-lg-8">

                                <Createpost />

                                {/* POSTS */}
                                {posts && posts.length > 0 ? (
                                    posts.map((post: any) => (
                                        <Postview
                                            key={post.post_id}
                                            id={post.post_id}
                                            user={post.client_name || `User ${post.client_user_id}`}

                                            time={
                                                post.created_at
                                                    ? new Date(post.created_at).toLocaleString()
                                                    : ""
                                            }

                                            des={post.post_content || ""}

                                            avater="user.png"

                                            postimage={
                                                post.post_image
                                                    ? `${UPLOAD_URL}/${post.post_image}`
                                                    : undefined
                                            }

                                            postvideo={
                                                post.post_video
                                                    ? `${UPLOAD_URL}/${post.post_video}`
                                                    : undefined
                                            }
                                        />
                                    ))
                                ) : (
                                    <p className="text-center mt-3">No posts found</p>
                                )}

                                <Load />
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <Popupchat />
            <Appfooter />
        </Fragment>
    );
};

export default Userpage;